/*
 * delivery-estimate-ui.js — 배송 추정 [UI 계층]
 * ---------------------------------------------------------------------------
 * <delivery-estimate> 커스텀 엘리먼트. 데이터(delivery-matrix) 조회 + 계산
 * (delivery-estimate)을 묶어, 배송 옵션(무료/특급)별 도착일을 렌더한다.
 * express 가 economy 와 같은 속도면 특급 행은 숨긴다(데이터/표현 분리).
 * 로케일 문자열은 자식 <script class="delivery-estimate-strings"> 에서 읽는다.
 */
(function () {
  'use strict';
  if (!window.WookieDelivery || !window.WookieDelivery.Matrix || !window.WookieDelivery.Estimate) return;
  if (customElements.get('delivery-estimate')) return;

  var NS = window.WookieDelivery;
  var Matrix = NS.Matrix;
  var Estimate = NS.Estimate;

  var COUNTRY_NAMES = {
    'AE': 'United Arab Emirates', 'AO': 'Angola', 'AT': 'Austria', 'AU': 'Australia',
    'BA': 'Bosnia and Herzegovina', 'BE': 'Belgium', 'BG': 'Bulgaria', 'BH': 'Bahrain',
    'BR': 'Brazil', 'CA': 'Canada', 'CH': 'Switzerland', 'CI': 'Ivory Coast',
    'CL': 'Chile', 'CN': 'China', 'CO': 'Colombia', 'CR': 'Costa Rica',
    'CY': 'Cyprus', 'CZ': 'Czech Republic', 'DE': 'Germany', 'DK': 'Denmark',
    'EE': 'Estonia', 'ES': 'Spain', 'FI': 'Finland', 'FR': 'France',
    'GB': 'United Kingdom', 'GH': 'Ghana', 'GI': 'Gibraltar', 'GR': 'Greece',
    'HK': 'Hong Kong', 'HR': 'Croatia', 'HU': 'Hungary', 'IE': 'Ireland',
    'IL': 'Israel', 'IN': 'India', 'IS': 'Iceland', 'IT': 'Italy',
    'JO': 'Jordan', 'JP': 'Japan', 'KE': 'Kenya', 'KR': 'South Korea',
    'KW': 'Kuwait', 'LI': 'Liechtenstein', 'LT': 'Lithuania', 'LU': 'Luxembourg',
    'LV': 'Latvia', 'MA': 'Morocco', 'MC': 'Monaco', 'ME': 'Montenegro',
    'MT': 'Malta', 'MX': 'Mexico', 'MY': 'Malaysia', 'NG': 'Nigeria',
    'NL': 'Netherlands', 'NO': 'Norway', 'NZ': 'New Zealand', 'OM': 'Oman',
    'PA': 'Panama', 'PE': 'Peru', 'PH': 'Philippines', 'PK': 'Pakistan',
    'PL': 'Poland', 'PR': 'Puerto Rico', 'PT': 'Portugal', 'PY': 'Paraguay',
    'QA': 'Qatar', 'RE': 'Réunion', 'RO': 'Romania', 'RS': 'Serbia',
    'RU': 'Russia', 'SA': 'Saudi Arabia', 'SE': 'Sweden', 'SG': 'Singapore',
    'SI': 'Slovenia', 'SK': 'Slovakia', 'TH': 'Thailand', 'TR': 'Turkey',
    'TW': 'Taiwan', 'TZ': 'Tanzania', 'UA': 'Ukraine', 'UM': 'U.S. Minor Outlying Islands',
    'US': 'United States', 'ZA': 'South Africa',
    'AM': 'Armenia', 'FJ': 'Fiji', 'GE': 'Georgia', 'KH': 'Cambodia', 'KZ': 'Kazakhstan',
    'MD': 'Moldova', 'MN': 'Mongolia', 'MO': 'Macau', 'UZ': 'Uzbekistan', 'VN': 'Vietnam'
  };
  function countryName(code) { return COUNTRY_NAMES[code] || code; }

  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      var d = this.dataset;
      var stringsEl = this.querySelector('.delivery-estimate-strings');
      this.S = {};
      if (stringsEl) { try { this.S = JSON.parse(stringsEl.textContent); } catch (e) { this.S = {}; } }

      this.origin = d.originCountry || 'KR';
      // 배송 국가는 컨텍스트(감지 결과)가 정본. data-country 는 서버가 렌더한 마켓 기본값이라
      // 컨텍스트가 아직 결정되지 않았을 때만 쓰는 폴백이다.
      this.currentCountry = NS.country || d.country || 'KR';
      this.cutoffHour = parseInt(d.cutoffHour, 10) || 15;
      this.prepDays = parseInt(d.prepDays, 10) || 1;
      this.manualHolidays = (d.manualHolidays || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);

      this.isLocalDelivery = d.isLocalDelivery === 'true';
      this.localDeliveryCountries = (d.localDeliveryCountries || '').split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
      this.localPrepDays = parseInt(d.localPrepDays, 10) || 1;
      this.localShipDays = parseInt(d.localShipDays, 10) || 3;
      this.localAdditionalDays = parseInt(d.localAdditionalDays, 10) || 1;
      var minP = parseFloat(d.minPercent) || 85;
      var maxP = parseFloat(d.maxPercent) || 115;
      var lmin = parseFloat(d.localMinPercent), lmax = parseFloat(d.localMaxPercent);
      this.localMinPercent = isNaN(lmin) ? minP : lmin;
      this.localMaxPercent = isNaN(lmax) ? maxP : lmax;

      // 매트릭스 원문은 layout 이 페이지당 1회만 내보낸다(delivery-context 가 DOM 에서 읽어 둠).
      // 여기서 별도 인스턴스를 만드는 이유는 블록 설정 폴백(country_ship_range_json·기본일·배수)을
      // 얹어야 하기 때문이며, 원문 자체는 공유한다(과거의 data-matrix 중복 출력은 제거됨).
      this.matrix = Matrix.create({
        matrixRaw: NS.matrixRaw || '{}',
        rangeRaw: d.countryShipRange || '{}',
        defaultDays: d.defaultShipDays,
        minPercent: minP,
        maxPercent: maxP
      });

      this.resultEl = this.querySelector('.delivery-estimate-result');
      this.select = this.querySelector('.delivery-country-select');
      this.populateSelector();

      if (this.select) this.select.addEventListener('change', () => this.update());
      this.update();
      this.ensureBadgeContrast();
    }

    populateSelector() {
      var sel = this.select;
      if (!sel) return;
      var codes = this.matrix.allCountryCodes().sort(function (a, b) {
        return countryName(a).localeCompare(countryName(b));
      });
      sel.innerHTML = '';
      var current = this.currentCountry, inList = false;
      codes.forEach(function (code) {
        var o = document.createElement('option');
        o.value = code; o.textContent = countryName(code);
        if (code === current) { o.selected = true; inList = true; }
        sel.appendChild(o);
      });
      if (!inList) {
        var o = document.createElement('option');
        o.value = current; o.textContent = countryName(current) + ' (default)'; o.selected = true;
        sel.insertBefore(o, sel.firstChild);
      }
    }

    formatDate(dt) {
      var wd = [this.S.weekday_sun, this.S.weekday_mon, this.S.weekday_tue, this.S.weekday_wed,
                this.S.weekday_thu, this.S.weekday_fri, this.S.weekday_sat];
      return (dt.getMonth() + 1) + '/' + dt.getDate() + '(' + (wd[dt.getDay()] || '') + ')';
    }

    optionRow(icon, label, win) {
      return '<div class="delivery-estimate-option"><span class="delivery-estimate-icon">' + icon +
        '</span> <span class="delivery-estimate-text">' + label + ': ' +
        this.formatDate(win.min) + ' ~ ' + this.formatDate(win.max) + '</span></div>';
    }

    async update() {
      if (!this.resultEl) return;
      this.resultEl.innerHTML = '<span class="delivery-estimate-icon">⏳</span> <span class="delivery-estimate-text">' +
        (this.S.calculating || '') + '</span>';

      var country = this.select ? this.select.value : this.currentCountry;

      // 셀렉터는 '만약 이 나라라면?' 미리보기다 — 저장하지 않고, 새로고침하면 감지 국가로 돌아간다.
      // 표시 반영(공지바 스팬 + 무료배송바 pubsub)의 규약은 delivery-context 가 단일 소유한다.
      if (NS && typeof NS.applyCountry === 'function') NS.applyCountry(country, true);

      var goal = this.matrix.lookup(country);

      var holidays = await Estimate.relevantHolidays(this.origin, this.manualHolidays);
      var ctx = { cutoffHour: this.cutoffHour, prepDays: this.prepDays, holidays: holidays, manualHolidays: this.manualHolidays };

      var isLocal = this.isLocalDelivery &&
        (this.localDeliveryCountries.length === 0 || this.localDeliveryCountries.indexOf(country.toUpperCase()) !== -1);
      if (isLocal) {
        var lctx = { cutoffHour: this.cutoffHour, prepDays: this.localPrepDays, holidays: holidays, manualHolidays: this.manualHolidays };
        var avg = Math.max(1, this.localShipDays);
        var lmin = Math.max(1, Math.floor(avg * (this.localMinPercent / 100)));
        var lmax = Math.max(lmin, Math.ceil(avg * (this.localMaxPercent / 100)));
        var lwin = Estimate.arrival({ min: lmin + this.localAdditionalDays, max: lmax + this.localAdditionalDays }, lctx);
        this.resultEl.innerHTML = this.optionRow('🌎', this.S.estimated_arrival_local || 'Estimated arrival', lwin);
        return;
      }

      var res = goal;
      var econWin = Estimate.arrival(res.economy, ctx);
      var econLabel = this.S.shipping_free || 'Free shipping';
      if (res.economy.free_over != null && res.economy.free_over > 0) {
        econLabel = (this.S.shipping_free_over || 'Free shipping ({amount}+)')
          .replace('{amount}', NS.formatMoney(res.economy.free_over, res.economy.currency));
      }
      var html = this.optionRow('📦', econLabel, econWin);

      if (res.express && !(res.express.min === res.economy.min && res.express.max === res.economy.max)) {
        var expWin = Estimate.arrival({ min: res.express.min, max: res.express.max }, ctx);
        var label = this.S.shipping_express || 'Express';
        if (res.express.price != null && res.express.price > 0) {
          label += ' +' + NS.formatMoney(res.express.price, res.express.currency);
        }
        html += this.optionRow('⚡', label, expWin);
      }
      this.resultEl.innerHTML = html;
    }

    ensureBadgeContrast() {
      try {
        var badge = this.querySelector('.local-delivery-badge');
        if (!badge) return;
        var auto = badge.dataset.autoContrast === 'true' || badge.dataset.autoContrast === 'True';
        if (!auto) return;
        var bg = badge.dataset.badgeColor || '';
        if (!bg || /^var\(/i.test(bg) || !(/^#?[0-9A-Fa-f]{3}$/.test(bg) || /^#?[0-9A-Fa-f]{6}$/.test(bg) || /^rgb\(/i.test(bg))) {
          bg = getComputedStyle(badge).backgroundColor || getComputedStyle(badge).getPropertyValue('--local-delivery-bg') || '#4CAF50';
        }
        bg = bg.trim();
        function parseHex(hex) {
          if (hex.indexOf('#') === 0) hex = hex.slice(1);
          if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
          return [parseInt(hex.substring(0, 2), 16), parseInt(hex.substring(2, 4), 16), parseInt(hex.substring(4, 6), 16)];
        }
        function lum(r, g, b) {
          var a = [r, g, b].map(function (v) { v = v / 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
          return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
        }
        var rgb = [76, 175, 80];
        if (/^#?[0-9A-Fa-f]{3}$/.test(bg) || /^#?[0-9A-Fa-f]{6}$/.test(bg)) rgb = parseHex(bg);
        else { var m = bg.match(/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+)/i); if (m) rgb = [parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10)]; }
        var L = lum(rgb[0], rgb[1], rgb[2]);
        var chosen = ((L + 0.05) / 1.05) > (1.05 / (L + 0.05)) ? '#FFFFFF' : '#000000';
        badge.style.setProperty('--local-delivery-text', chosen);
      } catch (e) { /* noop */ }
    }
  }

  customElements.define('delivery-estimate', DeliveryEstimate);
})();
